/** Membership grants and expiries are expressed in Central time, where ADN's calendar lives. */
export const MEMBERSHIP_TIME_ZONE = 'America/Chicago';

export function formatMembershipDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-US', {
    year: 'numeric', month: 'short', day: 'numeric', timeZone: MEMBERSHIP_TIME_ZONE
  });
}

/**
 * Access ends at the start of the period-end day, so the last day the org has
 * Pro is the day before. Stripe's invoices show it this way (Dec 31 for a 1/1
 * cutoff); matching it keeps ADN and the receipt telling one story.
 */
export function formatLastDayOfAccess(periodEndIso: string): string {
  return formatMembershipDate(new Date(new Date(periodEndIso).getTime() - 1000).toISOString());
}

/**
 * The instant at which `yyyy-mm-dd` begins in Central time. Tries both US
 * Central offsets (CDT -5, CST -6) and keeps the one that actually lands on
 * hour 0 in America/Chicago, so DST dates are right without a tz library.
 */
export function centralMidnight(date: string): Date {
  const [y, m, d] = date.split('-').map(Number);
  const hourFormat = new Intl.DateTimeFormat('en-US', { hour: 'numeric', hourCycle: 'h23', timeZone: MEMBERSHIP_TIME_ZONE });
  for (const offsetHours of [5, 6]) {
    const candidate = new Date(Date.UTC(y, m - 1, d, offsetHours));
    if (Number(hourFormat.format(candidate)) === 0) return candidate;
  }
  return new Date(Date.UTC(y, m - 1, d, 6));
}
